export const searchThemesFromTrendsSettingDrawer = {
    setting: 'Configuration',
    size: 'Bubble Size',
    xLabel: 'X Axis',
    yLabel: 'Y Axis',
    zoomSlider: 'Zoom Slider',
    labelFixMode: 'Label Fix',
    initButton: 'Revert to Default'
}
